import React from 'react'
import { normalizeImageUrl } from '../utils/urlSanitizer'
import { Helmet } from 'react-helmet'

// Meta component with canonical, robots, OpenGraph and Twitter support
const Meta = ({
  title,
  description,
  keywords,
  canonical,
  robots,
  og,
  twitter,
}) => {
  const ogTags = og || {}
  const twTags = twitter || {}
  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name='description' content={description} />}
      {keywords && <meta name='keyword' content={keywords} />}

      {canonical && <link rel='canonical' href={canonical} />}
      {robots && <meta name='robots' content={robots} />}

      {/* Open Graph (Facebook/LinkedIn) */}
      {ogTags.title && <meta property='og:title' content={ogTags.title} />}
      {ogTags.description && (
        <meta property='og:description' content={ogTags.description} />
      )}
      {ogTags.url && <meta property='og:url' content={ogTags.url} />}
  {ogTags.image && <meta property='og:image' content={normalizeImageUrl(ogTags.image)} />} 
      {ogTags.type && <meta property='og:type' content={ogTags.type} />}

      {/* Twitter Cards */}
      {(twTags.card || (twTags.image && 'summary_large_image')) && (
        <meta
          name='twitter:card'
          content={twTags.card || 'summary_large_image'}
        />
      )}
      {twTags.title && <meta name='twitter:title' content={twTags.title} />}
      {twTags.description && (
        <meta name='twitter:description' content={twTags.description} />
      )}
  {twTags.image && <meta name='twitter:image' content={normalizeImageUrl(twTags.image)} />}
    </Helmet>
  )
}

Meta.defaultProps = {
  title: 'The Lotustor',
  description: 'We sell the best products for cheap',
  keywords: 'electronics, buy electronics, cheap electroincs',
}

export default Meta
